import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default () => {
	const blocks = document.querySelectorAll(".img-scroll");
  
  blocks.forEach(function(block) {
    let media = block.querySelector(".img-scroll__el");
    if (!media) return;
    let blockHeight = block.offsetHeight;
    let mediaHeight = media.offsetHeight;
    let yMove = 100*(mediaHeight - blockHeight)/mediaHeight;

    yMove = Math.round(yMove * 1000) / 1000;
    
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: block,
        start: 'top bottom',
        end: 'bottom top',
        scrub: true,
      }
    });

    tl.fromTo(media, {
      yPercent: -yMove
    }, {
      yPercent: 0
    });


  });
}